































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IWifiConfig } from "@/@types/filoxenia-config/tv-config";

import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: { StandartModal, onsubmit: SubmitResetButtonGroop },
})
export default class WifiConfig extends Vue {
  @Prop({ type: String, default: "" }) wifi!: IWifiConfig | undefined;

  name = "";
  password = "";

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    this.$emit("updateConfig", {
      wifi_config: { name: this.name, password: this.password },
    });
    this.$bvModal.hide("wifi-config-settings");
  }

  cteatedLocales(): void {
    this.name = this.wifi ? this.wifi.name : "";
    this.password = this.wifi ? this.wifi.password : "";
  }

  @Watch("wifi")
  onWifiChanged(): void {
    this.cteatedLocales();
  }

  onReset(): void {
    this.cteatedLocales();
  }

  mounted(): void {
    this.cteatedLocales();
  }
}
